import styled from 'styled-components';
export const HeaderFooter = styled.div`
    display: grid;
    grid-template-columns: min-content 1fr min-content;
    grid-template-rows: 1fr;
    gap: 1px 1px;
    grid-template-areas: 'left-content center-content right-content';
    .grid-content {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1em;
        overflow: hidden;
    }
    .left-content {
        grid-area: left-content;
    }

    .center-content {
        grid-area: center-content;
    }

    .right-content {
        grid-area: right-content;
    }
`;
